// Expo Router dynamic route for a single federal registration. The screen body lives in a
// bracket-free sibling (RegistrationDetailScreen) so unit tests can import it without a `[id]` path.
import { RegistrationDetailScreen } from './RegistrationDetailScreen';

export default function RegistrationDetailRoute() {
  return <RegistrationDetailScreen />;
}
